import {unreachable} from "@prosay/common"
import {translate} from "@prosay/i18n"
import {getLogger} from "@prosay/logging"
import {ConversationInfoFragment, MessageInfoFragment} from "../graphql"

const logger = getLogger(__filename)

export const getStatusText = (
    {lawyer, status}: ConversationInfoFragment,
    short = false,
) => {
    switch (status) {
        case "InformationGathering":
            return translate("conversation.status.informationGathering")
        case "InProgress":
            if (short || !lawyer?.lawyerTitle) {
                return translate("conversation.status.inProgressShort")
            }
            return translate("conversation.status.inProgress", {
                lawyerTitle: lawyer.lawyerTitle,
            })
        case "LookingForLawyer":
            return translate("conversation.status.lookingForLawyer")
        case "Resolved":
            return translate("conversation.status.resolved")
        default:
            unreachable()
    }
}

export const compareMessagesByDate = logger.debug(
    (lhs: MessageInfoFragment, rhs: MessageInfoFragment) =>
        new Date(rhs.createdAt).getTime() - new Date(lhs.createdAt).getTime(),
    "compareMessagesByDate",
)
